import Service from "../../AuthService";

const TaxPayoff = {
    getTaxInvoice(page) {
        return Service.get("/tax_rr_payoff?page="+page);
    },
    showTaxInvoice(id) {
        return Service.get("/tax_rr_payoff/" + id);
    },
    updateTaxInvoice(id, data) {
        return Service.put("/tax_rr_payoff/" + id, data);
    },
    createTaxInvoice(data) {
        return Service.post("/tax_rr_payoff", data);
    },
    deleteTaxInvoice(id) {
        return Service.delete("/tax_rr_payoff/" + id);
    },
};

export default TaxPayoff
